import { useState } from 'react'
import { isAxiosError } from 'axios'
import { createCustomFlashcard } from '@/api/customFlashcards'
import type { CustomFlashcardInput } from '@/types/customFlashcard'

/** Shared create-submit state for the custom flashcard forms (vocab page + reading popover). */
export function useCreateCustomFlashcard(onCreated: () => void) {
  const [submitting, setSubmitting] = useState(false)
  const [errors, setErrors] = useState<Record<string, string[]>>({})

  function create(input: CustomFlashcardInput) {
    setSubmitting(true)
    setErrors({})
    createCustomFlashcard(input)
      .then(onCreated)
      .catch((err: unknown) => {
        if (isAxiosError(err) && err.response?.data?.errors) {
          setErrors(err.response.data.errors as Record<string, string[]>)
        } else {
          setErrors({ base: ['Something went wrong. Please try again.'] })
        }
      })
      .finally(() => setSubmitting(false))
  }

  return { create, submitting, errors }
}
